import styled from 'styled-components'


export const RegisterTitle = styled.h1`
text-align: center;
font-family: 'Shadows Into Light', cursive;
font-weight:bold;
`
export const RegisterConteiner = styled.div`
font-family: 'Indie Flower', cursive;
font-weight:bold;
background-repeat: no-repeat;
 background-image: url('images/backgrounds/background12.jpg');
 background-position: center;
`
